import * as React from 'react';

import { Input } from '../Form';
import { useIntl } from '../../providers';

interface AddressProps {
    errors?: any;
    register: (options: object) => any;
    customerInformation: string;
}

const Address: React.FC<AddressProps> = ({ errors, register, customerInformation }: AddressProps) => {
    const { translate } = useIntl();

    return (
        <>
            <Input
                name="street"
                label={translate('orderForm.field.street', 'Street')}
                register={register}
                disabled={!!customerInformation}
                required={!customerInformation}
                error={errors?.street}
            />
            <Input
                name="city"
                label={translate('orderForm.field.city', 'Zipcode / City')}
                register={register}
                disabled={!!customerInformation}
                required={!customerInformation}
                error={errors?.city}
            />
            <Input
                name="country"
                label={translate('orderForm.field.country', 'Country')}
                register={register}
                disabled={!!customerInformation}
                required={!customerInformation}
                error={errors?.country}
            />
        </>
    );
};

export default React.memo(Address);
